module.exports = __webpack_public_path__ + "static/media/export.e78e3e2f.svg";